import type { SupportedLocale } from '@/shared/i18n/SupportedLocale';
import { fromNow } from '@/shared/util/fromNow';
import clsx from 'clsx';
import React from 'react';

export type DateFormatNowProps = {
  className?: string;
  value: string | Date;
  format: string;
  locale: SupportedLocale;
};

export function DateFormatNow(props: DateFormatNowProps) {
  const { className, value, format, locale } = props;

  const [displayValue, setDisplayValue] = React.useState(format);

  React.useEffect(() => {
    setDisplayValue(fromNow(value, locale));
  }, [value, locale]);

  return <span className={clsx('', className)}>{displayValue}</span>;
}
